import { LoadPanel, Toast } from "devextreme-react";
import warning from "../../../../images/warning.png";
import { ViewProductFunction } from "../ViewProductFunction";
import { useState } from "react";
import { useSelector } from "react-redux";
export const ReGenerate = ({
  ReGeneratePopupShow,
  setReGeneratePopupShow,
  setauthData,
  SetcopY,
}) => {
  const clas = new ViewProductFunction();
  const { viewData } = useSelector((store) => store.dashboard);
  const [loading, setLoading] = useState(false);
  const [toastConfig, setToastConfig] = useState({
    isVisible: false,
    type: "",
    message: "",
  });
  return (
    <>
      <LoadPanel shadingColor="true" visible={loading} delay={10} />
      <Toast
        visible={toastConfig.isVisible}
        message={toastConfig.message}
        type={toastConfig.type}
        position={"top"}
        width={"auto"}
      />
      <div className="modal--trash" id="TrashAppModal" role="dialog">
        <div className="modal__dialog modal__dialog--sm">
          <div className="modal__content">
            <div className="modal__body">
              <button
                onClick={() => {
                  setReGeneratePopupShow(false);
                }}
                className="btnClose"
              >
                <svg
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clipPath="url(#clip0_51_1221)">
                    <path
                      d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
                      fill="black"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_51_1221">
                      <rect width={24} height={24} fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </button>
              <div className="infoBox">
                <div className="infoBox__icon">
                  <img style={{ width: "40px" }} src={warning} alt="alert icon" />
                </div>
                <div className="title">
                  Are you sure you want to regenerate new access keys now? This
                  action is irreversible and will replace the current keys.
                </div>
              </div>
              <div className="form__group form__group--btnflex">
                <button
                  className="btn btn--blueOutline"
                  onClick={() => {
                    clas.Regenerate(
                      setLoading,
                      viewData,
                      setauthData,
                      toastConfig,
                      setToastConfig,
                      setReGeneratePopupShow,
                      SetcopY
                    );
                  }}
                >
                  Yes
                </button>
                <button
                  className="btn btn--gray"
                  onClick={() => {
                    setReGeneratePopupShow(false);
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
